<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M25.6569 20.3431C22.5327 17.219 17.4673 17.219 14.3431 20.3431L6.34315 28.3431C3.21895 31.4673 3.21895 36.5327 6.34315 39.6569C9.46734 42.781 14.5327 42.781 17.6569 39.6569L19.86 37.4537M18.3431 27.6569C21.4673 30.781 26.5327 30.781 29.6569 27.6569L37.6569 19.6569C40.781 16.5327 40.781 11.4673 37.6569 8.34315C34.5327 5.21895 29.4673 5.21895 26.3431 8.34315L24.1439 10.5424"
    stroke="currentColor"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
